import { RouteComponentProps } from 'react-router-dom';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { convertFilterToArray } from 'src/utils/convertFilter';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import { fetchMerchantByIdRequest, fetchMerchantsRequest, fetchMerchantUpdateRequest } from './requestHandlers';
import { IMerchant, IMerchantListData } from './types';

export const loadMerchantsStart = createAction('merchants/load/start');

export const loadMerchantsListSuccess = createAction<IMerchantListData>('merchants/load/success');
export const loadMerchantDetailsSuccess = createAction<IMerchant>('merchants/details/load/success');
export const resetMerchantDetails = createAction('merchants/details/reset');

const defaultParams = {
  page: '0',
  size: '10',
};

export const loadMerchantsRequest = (
  history: RouteComponentProps['history'],
  params: IQueryParams = {},
  isInitialLoading?: boolean,
  type?: string,
) => {
  return async (dispatch: AppDispatch): Promise<boolean> => {
    if (isInitialLoading) {
      dispatch(loadMerchantsStart());
    }

    const initialParams = qs.parse(history.location.search);
    const mergedParams = type === 'reset' ? defaultParams : removeEmpty({ ...defaultParams, ...initialParams, ...params });

    mergedParams.siteIds = convertFilterToArray(mergedParams.siteIds);

    const data = await fetchMerchantsRequest(mergedParams);
    if (data) {
      dispatch(loadMerchantsListSuccess(data));
      history.replace({
        search: qs.stringify(mergedParams, { skipNull: true }),
      });
    }

    return true;
  };
};

export const loadMerchantDetailsRequest = (id: string) => {
  return async (dispatch: AppDispatch): Promise<boolean> => {
    dispatch(loadMerchantsStart());

    const data = await fetchMerchantByIdRequest(id);

    if (data) {
      dispatch(loadMerchantDetailsSuccess(data));
    }

    return true;
  };
};

export const updateMerchant = (id: number, data: Partial<IMerchant>) => {
  return async (dispatch: AppDispatch): Promise<IMerchant | null> => {
    const res = await fetchMerchantUpdateRequest(id, data);
    if (res) {
      dispatch(loadMerchantDetailsSuccess(res));
    }
    return res;
  };
};
